export const CrossTypes = [
  "Unspecified",
  "Cousin",
  "Sibling",
  "Sibling, Cousin",
  "Self, Sibling",
  "Self, Sibling, Cousin",
  "Total",
];
